var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlantasSol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1279_688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 15.6717C1 7.56876 7.56876 1 15.6717 1L37 1V22.3283C37 30.4312 30.4312 37 22.3283 37H1L1 15.6717Z",
    fill: "#69BF8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1557 1V0.844262H37L15.6717 0.844262C7.48275 0.844262 0.844262 7.48275 0.844262 15.6717L0.844262 37V37.1557H1H22.3283C30.5173 37.1557 37.1557 30.5173 37.1557 22.3283V1Z",
    stroke: "url(#paint0_linear_1279_688)",
    strokeWidth: 0.311475
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2603 12.9178L12.6164 11.2831L11.3288 12.5708L12.9635 14.2055L14.2603 12.9178ZM9 18.0868H11.7397V19.9132H9V18.0868ZM18.1324 9H19.9589V11.6941H18.1324V9ZM25.4749 11.2785L26.7607 12.5635L25.126 14.1982L23.8411 12.9123L25.4749 11.2785ZM23.831 25.0822L25.4658 26.726L26.7534 25.4384L25.1096 23.8037L23.831 25.0822ZM26.3516 18.0868H29.0913V19.9132H26.3516V18.0868ZM19.0457 13.5205C16.0228 13.5205 13.5662 15.9772 13.5662 19C13.5662 22.0228 16.0228 24.4795 19.0457 24.4795C22.0685 24.4795 24.5251 22.0228 24.5251 19C24.5251 15.9772 22.0685 13.5205 19.0457 13.5205ZM19.0457 22.653C17.0274 22.653 15.3927 21.0183 15.3927 19C15.3927 16.9817 17.0274 15.347 19.0457 15.347C21.0639 15.347 22.6986 16.9817 22.6986 19C22.6986 21.0183 21.0639 22.653 19.0457 22.653ZM18.1324 26.3059H19.9589V29H18.1324V26.3059ZM11.3288 25.4292L12.6164 26.7169L14.2511 25.0731L12.9635 23.7854L11.3288 25.4292Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1279_688",
    x: -2.75015,
    y: -2.75021,
    width: 43.5003,
    height: 43.5004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 1.71934
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1279_688"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1279_688",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1279_688",
    x1: 11.2857,
    y1: -4.90164,
    x2: 30.9983,
    y2: 43.8391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantasSol);
export default __webpack_public_path__ + "static/media/plantasSol.abe212252d270d7c18674b90f513404d.svg";
export { ForwardRef as ReactComponent };